import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { BusinessGroupRequest, BusinessGroupsService } from '@src/app/shared/backend/clients';
import { BaseViewComponent } from '@src/app/shared/components/base-list/base-view.component';

@Component({
    selector: 'app-add-business-group',
    templateUrl: './add-business-group.component.html',
    styleUrl: './add-business-group.component.scss',
    host: {
        class: 'app-add-business-group'
    },
    standalone: false
})
export class AddBusinessGroupComponent extends BaseViewComponent implements OnInit {

  totalRecords: number = 0;
  rowsPerPageOption: number = 5;

  public businessGroupForm: FormGroup = this.fb.group({
    name: ['', [Validators.required, Validators.maxLength(50)]],
    code: ['', [Validators.required, Validators.maxLength(50)]]
  });

  constructor(
    private router: Router,
    private businessGroupsService: BusinessGroupsService,
    private fb: FormBuilder
  ) { super(); }

  ngOnInit() { }

  async submitForm() {
    if (this.businessGroupForm.valid) {
      const payload: BusinessGroupRequest = {
        name: this.businessGroupForm.controls['name'].value,
        code: this.businessGroupForm.controls['code'].value
      };

      await firstValueFrom(this.businessGroupsService.apiBusinessGroupsCreatePost(payload));

      this.businessGroupForm.controls['code'].setValue(null);
      this.businessGroupForm.controls['name'].setValue(null);

      this.router.navigate(['/business-groups']);
    }
  }
}
